import { GetStaticProps, NextPage } from 'next'
import React from 'react'
import { ContentPage } from 'src/components/ContentPage/ContentPage'
import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { withRetries } from 'src/utils/retryHelper'

type Props = {
  slug: string
  content: any
}

const IndustryAnalysis: NextPage<Props> = ({ content, slug }) => {
  return <ContentPage slug={slug} content={content} origin={`/industry-analysis/${slug}/`} />
}

export default IndustryAnalysis

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  if (!params?.slug || THEME === 'ilta') {
    return {
      revalidate: 60,
      notFound: true,
    }
  }
  const slug = params.slug as string
  try {
    const { contentBySlug: content } = await withRetries(() => apolloSdk.contentBySlug({ slug }))

    if (!content) {
      return {
        revalidate: 60,
        notFound: true,
      }
    }

    return {
      props: {
        slug,
        content,
      },
      revalidate: 60, // Only cache successful pages
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching industry analysis:', error)
    return {
      notFound: true,
      revalidate: 5,
    }
  }
}

export async function getStaticPaths() {
  const start = 0
  const { contents } = await apolloSdk.allIndustryAnalysisSlugs({ start })
  const result = contents || []

  const paths = result
    .filter((item) => !!item)
    .map((item) => {
      const slug = item?.slug
      return {
        params: { slug },
      }
    })
  return {
    paths,
    fallback: 'blocking',
  }
}
